$(function()
{
    var $_map = null;
    var $_countriesSelect = null;
    var $_panelViews = null;
    var $_panelScrollView = null;
    var $_panelParties = null;
    var $_panelParty = null;
    var $_panelSearchResult = null;
    var $_selectedMapArea = null;
    var $_printOverview = null;
    var $_printAll = null;
    var $_printCountry = null;
    var $_printParty = null;

    var _enableMapResponsiveness = false;
    var _partiesTemplate = null;
    var _partyTemplate = null;
    var _searchResultTemplate = null;
    var _socialsClasses = null;

    var _currentCountry = null;
    var _currentParty = null;
    var _currentSearch = null;




    function resetParties() { $_panelParties.html(''); $_printCountry.fadeOut(); }
    function resetParty() { $_panelParty.html(''); $_printParty.fadeOut(); }
    function resetSearchResults() { $_panelSearchResult.html(''); }




    function checkCurrentSearch()
    {
        if(_currentSearch != null)
        {
            $_panelScrollView.removeClass('p-search');

            setTimeout(function()
            {
                resetSearchResults();
            }, 350);

            _currentSearch = null;
        }
    }


    function checkCurrentParty()
    {
        if(_currentParty != null)
        {
            $_panelScrollView.removeClass('p-details');

            setTimeout(function()
            {
                resetParty();
            }, 350);

            _currentParty = null;
        }
    }


    function checkCurrentCountry()
    {
        if(_currentCountry != null)
        {
            resetParties();

            $_selectedMapArea.mapster('deselect');

            _currentCountry = null;
        }
    }




    function selectCountryInCountriesSelect(__country)
    {
        $_countriesSelect.find('option[value="' + __country.array_id + '"]').prop('selected', true);
        $_countriesSelect.parent().find('.customSelect .customSelectInner').text(__country.name);
    }


    function resetCountriesSelect()
    {
        $_countriesSelect.find('option:eq(0)').prop('selected', true);

        var defaultValue = $_countriesSelect.find('option:selected').text();
        $_countriesSelect.parent().find('.customSelect .customSelectInner').text(defaultValue);
    }




    function openPanelViews()
    {
        if(!$_panelViews.is(':visible'))
        {
            $_panelViews.slideDown(350);
        }
    }


    function scrollToPanelParty()
    {
        rsScrollTo(($_panelParty.offset().top - 105 - 20), 500);
    }


    function scrollToPanelViews()
    {
        rsScrollTo(($_panelViews.offset().top - 105 - 20), 500);
    }




    function getCountryWithName(__name)
    {
        var country = null;

        for (var i = 0; i < MEMBERS.length; i++)
        {
            var currentCountry = MEMBERS[i];

            if(currentCountry.name.replace(' ','') == __name.replace(' ',''))
            {
                country = currentCountry;
                break;
            }
        }

        return country;
    }




    function getSocialIconWithUrl(__url)
    {
        var icon = 'fa-globe';

        for (var j = 0; j < _socialsClasses.length; j++)
        {
            var socialClass = _socialsClasses[j];

            if(__url.indexOf(socialClass.name) != -1)
            {
                icon = 'fa-' + socialClass.icon;
                break;
            }
        }

        return icon;
    }




    function openCountry(__country)
    {
        $_map.mapster('set', true, __country.name);
        $_selectedMapArea = $('area[data-group="' + __country.name + '"]');

        onClickMapArea({'key': __country.name}); // Je crée l'objet nécessaire dans la méthode pour ne pas faire une passerelle pas vraiment utile ici vu la mini manipulation nécessaire
    }




    function buildSearchResults(__search, __countries, __parties)
    {
        var countriesHtml = '';
        var partiesHtml = '';


        if(__countries.length > 0)
        {
            countriesHtml = '<ul class="js-countries">';

            for (var i = 0; i < __countries.length; i++)
            {
                var country = __countries[i];

                countriesHtml += '<li><a href="#" data-country-id="' + country.array_id + '">' + country.name + '</a></li>';
            }

            countriesHtml += '</ul>';
        }
        else
        {
            countriesHtml = '<p><i>No match found.</i></p>'
        }


        if(__parties.length > 0)
        {
            partiesHtml = '<ul class="js-parties">';

            for (var i = 0; i < __parties.length; i++)
            {
                var party = __parties[i];

                partiesHtml += '<li><a href="#" data-country-id="' + party.country_array_id + '" data-party-id="' + party.array_id + '">' + party.name + '</a></li>';
            }

            partiesHtml += '</ul>';
        }
        else
        {
            partiesHtml = '<p><i>No match found.</i></p>'
        }


        var html = String(_searchResultTemplate);
        html = html.split('*|SEARCH|*').join(__search);
        html = html.split('*|COUNTRIES|*').join(countriesHtml);
        html = html.split('*|PARTIES|*').join(partiesHtml);

        $_panelSearchResult.html(html);


        $_panelSearchResult.find('.js-countries a').click(function(__event)
        {
            __event.preventDefault();

            var countryId = $(this).data('country-id');
            var country = MEMBERS[countryId];

            openCountry(country);
        });


        $_panelSearchResult.find('.js-parties a').click(function(__event)
        {
            __event.preventDefault();

            var countryId = $(this).data('country-id');
            var partyId = $(this).data('party-id');
            var country = MEMBERS[countryId];

            openCountry(country);
            onClickParty(country, country.parties[partyId]);
        });
    }




    function onClickParty(__country, __party)
    {
        if(_currentParty == null)
        {
            buildPanelPartyWithCountryAndParty(__country, __party);

            $_panelScrollView.addClass('p-details');
        }
        else
        {
            $_panelParty.fadeOut(250, function()
            {
                resetParty();
                buildPanelPartyWithCountryAndParty(__country, __party);

                $(this).fadeIn(350, function()
                {
                    $(this).removeAttr('style');
                });
            });
        }

        scrollToPanelParty();

        $('.js__back-to-country').bind('click', function(){
            _currentParty = null;
            _currentCountry = 'TEMP';
            $_panelScrollView.removeClass('p-details');
            onClickMapArea({'key': __country.name});
        })
        _currentParty = __party;
    }


    function buildPartyElement($__li, __country, __party)
    {
        var $party = $__li.clone();
        var $a = $party.find('a');
        var $img = $party.find('img');

        $a.data('country-id', __country.array_id);
        $a.data('party-id', __party.array_id);
        //$a.attr('href', '#' + __party.guid);
        $a.attr('title', __party.name);
        $img.attr('src', __party.logo.url);
        $img.attr('width', __party.logo.width);
        $img.attr('height', __party.logo.height);

        $a.click(function(__event)
        {
            __event.preventDefault();

            var countryId = $(this).data('country-id');
            var partyId = $(this).data('party-id');

            onClickParty(MEMBERS[countryId], MEMBERS[countryId].parties[partyId]);
        });

        return $party;
    }




    function buildPanelPartyWithCountryAndParty(__country, __party)
    {
        var address = __party.street;
        if((address != '') && ((__party.zipcode != '') || (__party.locality != ''))) address += '<br>';
        address += __party.zipcode;
        if(__party.zipcode != '') address += ' ';
        address += __party.locality;

        if(address == '') address = '/';


        var contacts = '';
        if(__party.phone != '') contacts += '<i class="fa fa-phone"></i> <a href="callto:' + __party.phone + '">' + __party.phone + '</a>';

        if(__party.fax != '')
        {
            if(contacts != '') contacts += '<br>';
            contacts += '<i class="fa fa-fax"></i> <a href="callto:' + __party.fax + '">' + __party.fax + '</a>';
        }

        if(__party.email != '')
        {
            if(contacts != '') contacts += '<br>';
            contacts += '<i class="fa fa-envelope"></i> <a href="mailto:' + __party.email + '">' + __party.email + '</a>';
        }

        if(contacts == '') contacts = '/';


        var websiteUrl = ((__party.website != null) && (__party.website != '')) ? __party.website : '';
        if((websiteUrl != '') && (websiteUrl.indexOf('http://') == -1)) websiteUrl = 'http://' + websiteUrl;

        var websiteLabel = (websiteUrl != '') ? websiteUrl.substr(7) : 'NC';

        //var entryDate = ((__party.entry_date != null) && (__party.entry_date != '')) ? __party.entry_date : 'NC';
        var president = ((__party.president != null) && (__party.president != '')) ? __party.president : 'NC';
        var secretaryGeneral = ((__party.secretary_general != null) && (__party.secretary_general != '')) ? __party.secretary_general : 'NC';
        var internationalSecretary = ((__party.international_secretary != null) && (__party.international_secretary != '')) ? __party.international_secretary : 'NC';
        var delegates = (((__party.delegates != null) && (__party.delegates != '') || (__party.delegates == 0))) ? __party.delegates : 'NC';
        var additionals = ((__party.additionals != null) && (__party.additionals != '')) ? __party.additionals : 'None';

        var html = String(_partyTemplate);
        html = html.split('*|TYPE_MEMBER|*').join(__country.type_member);
        html = html.split('*|COUNTRY_NAME|*').join(__country.name);
        html = html.split('*|PARTY_WEBSITE_URL|*').join(websiteUrl);
        html = html.split('*|PARTY_WEBSITE_LABEL|*').join(websiteLabel);
        html = html.split('*|PARTY_NAME|*').join(__party.name);
        //html = html.split('*|ENTRY_DATE|*').join(entryDate);
        html = html.split('*|STATUS|*').join(__party.status);
        html = html.split('*|PRESIDENT|*').join(president);
        html = html.split('*|SECRETARY_GENERAL|*').join(secretaryGeneral);
        html = html.split('*|INTERNATIONAL_SECRETARY|*').join(internationalSecretary);
        html = html.split('*|DELEGATES|*').join(delegates);
        html = html.split('*|ADDITIONALS|*').join(additionals);
        html = html.split('*|ADDRESS|*').join(address);
        html = html.split('*|CONTACTS|*').join(contacts);

        $_panelParty.html(html);

        if (secretaryGeneral  == 'NC') {
            $('.js__secretarygen').remove();
        }
        if (internationalSecretary  == 'NC') {
            $('.js__secretaryint').remove();
        }

        var $logo = $_panelParty.find('img.js-logo');
        var $partySocials = $_panelParty.find('.js-party-socials');
        var $leaderSocials = $_panelParty.find('.js-leader-socials');
        var $others = $_panelParty.find('.js-others');

        $logo.attr('src', __party.logo.url);
        $logo.attr('width', __party.logo.width);
        $logo.attr('height', __party.logo.height);


        if(__party.socials.length > 0)
        {
            var $li =  $partySocials.find('li').detach();

            for (var i = 0; i < __party.socials.length; i++)
            {
                var url = __party.socials[i];
                var icon = getSocialIconWithUrl(url);

                var $social = $li.clone();
                var $a = $social.find('a');
                var $fa = $social.find('.fa');

                $a.attr('href', url);
                $fa.addClass(icon);

                $partySocials.append($social);
            }
        }
        else
        {
            $partySocials.html('/');
        }


        if(__party.leader_socials.length > 0)
        {
            var $li =  $leaderSocials.find('li').detach();

            for (var i = 0; i < __party.leader_socials.length; i++)
            {
                var url = __party.leader_socials[i];
                var icon = getSocialIconWithUrl(url);

                var $social = $li.clone();
                var $a = $social.find('a');
                var $fa = $social.find('.fa');

                $a.attr('href', url);
                $fa.addClass(icon);

                $leaderSocials.append($social);
            }
        }
        else
        {
            $leaderSocials.html('/');
        }


        if(__country.parties.length > 1)
        {
            var $li =  $others.find('li').detach();

            for (var i = 0; i < __country.parties.length; i++)
            {
                var party = __country.parties[i];
                var $party = buildPartyElement($li, __country, party);

                if(party == __party) $party.addClass('active');

                $others.find('ul').append($party);
            }
        }
        else
        {
            $others.remove();
        }


        $_printParty.data('index', __party.array_id).fadeIn();
    }





    function buildPanelPartiesWithCountry(__country)
    {
        var html = String(_partiesTemplate);
        html = html.split('*|COUNTRY_NAME|*').join(__country.name);
        html = html.split('*|TYPE_MEMBER|*').join(__country.type_member);

        $_panelParties.html(html);

        var $li = $_panelParties.find('li').detach();

        for (var i = 0; i < __country.parties.length; i++)
        {
            var party = __country.parties[i];
            var $party = buildPartyElement($li, __country, party);

            $_panelParties.find('ul').append($party);
        }


        $_printCountry.data('name', __country.name).fadeIn();

        $('.js__back-to-all').bind('click', function(){
            _currentCountry = null;
            initMemberListView();
        })
    }




    function initSearchForm()
    {
        $('form[name="search"]').submit(function(__event)
        {
            __event.preventDefault();

            var $input = $('input[name="search"]');
            var placeholder = $input.attr('placeholder');
            var search = $input.val();

            if((search == placeholder) || (search == '')) return;


            resetCountriesSelect();
            checkCurrentParty();
            checkCurrentCountry();


            var countries = new Array();
            var parties = new Array();

            for (var i = 0; i < MEMBERS.length; i++)
            {
                var country = MEMBERS[i];

                if(country.name.toLowerCase().indexOf(search.toLowerCase()) != -1) countries.push(country);

                for (var j = 0; j < country.parties.length; j++)
                {
                    var party = country.parties[j];

                    if(party.name.toLowerCase().indexOf(search.toLowerCase()) != -1) parties.push(party);
                }
            }


            if(_currentSearch == null)
            {
                buildSearchResults(search, countries, parties);
                $_panelScrollView.removeClass('p-details-2');
                $_panelScrollView.addClass('p-search');
            }
            else
            {
                $_panelScrollView.removeClass('p-details-2');
                $_panelSearchResult.fadeOut(250, function()
                {
                    buildSearchResults(search, countries, parties);

                    $(this).fadeIn(350, function()
                    {
                        $(this).removeAttr('style');
                    });
                });
            }

            openPanelViews();

            _currentSearch = search;

            $('.js__back-to-all').bind('click', function(){
                _currentCountry = null;
                initMemberListView();
            })
        });
    }




    function resizeMap(__maxWidth, __maxHeight)
    {
        var imgWidth = $_map.width();
        var imgHeight = $_map.height();
        var newWidth = 0;
        var newHeight = 0;

        if((imgWidth / __maxWidth) > (imgHeight / __maxHeight)) newWidth = __maxWidth;
        else newHeight = __maxHeight;

        $_map.mapster('resize', newWidth, newHeight, 100);
    }




    function initResize()
    {
        $(window).resize(function()
        {
            var $window = $(this);

            var currentWidth = $window.width();
            var currentHeight = $window.height();
            var checking = false;

            if(checking) return;
            checking = true;

            setTimeout(function()
            {
                var newWidth = $window.width();
                var newHeight = $window.height();

                if((newWidth === currentWidth) && (newHeight === currentHeight))
                {
                    resizeMap(newWidth, newHeight);
                }

                checking = false;
            }, 100);
        });
    }




    function onClickMapArea(__data)
    {
        var country = getCountryWithName(__data.key);

        if(country == null)
        {
            alert('Sorry, no match found for this country.');
            return;
        }

        $_panelScrollView.removeClass('p-details-2');

        checkCurrentSearch();
        checkCurrentParty();
        selectCountryInCountriesSelect(country);


        if(_currentCountry != null)
        {
            var $activeCountryZoom = $('.js-countries-zooms a.active');
            if($activeCountryZoom.length > 0) $activeCountryZoom.removeClass('active');

            if(country != _currentCountry)
            {
                $('.js-countries-zooms a[data-name="' + country.name + '"]').addClass('active');

                $_panelParties.fadeOut(250, function()
                {
                    buildPanelPartiesWithCountry(country);

                    $(this).fadeIn(350, function()
                    {
                        $(this).removeAttr('style');
                    });
                });
            }
            else
            {
                $_panelViews.slideUp(250, function()
                {
                    resetParties();
                    initMemberListView();

                    _currentCountry = null;
                });

                return;
            }
        }
        else
        {
            $('.js-countries-zooms a[data-name="' + country.name + '"]').addClass('active');

            buildPanelPartiesWithCountry(country);
        }

        openPanelViews();
        scrollToPanelViews();
        _currentCountry = country;
    }


    function initMap()
    {
        // Repositionnement de la zone "San Marino" pour qu'elle passe au-dessus de l'Italie

        var $mapSanMarino = $('map[name="members"] area[data-group="San Marino"]').detach();
        $('map[name="members"]').prepend($mapSanMarino);

        //////

        $_map.mapster(
            {
                fillColor: '009fe3',
                fillOpacity: 1,
                stroke: false,
                singleSelect: true,
                mapKey: 'data-group', // Groups
                scaleMap: _enableMapResponsiveness,
                onClick: function(__data)
                {
                    //console.log(this); console.log(__data);

                    $_selectedMapArea = $(this);

                    onClickMapArea(__data);
                }
            });
    }




    function initCountriesSelect()
    {
        $_countriesSelect.customSelect(
            {
                checkInnerHeight: true,
                fitToContent : false
            });


        $_countriesSelect.change(function()
        {
            var countryId = $(this).val();
            if(countryId == '') return;

            var country = MEMBERS[parseInt(countryId)];

            openCountry(country);
        });
    }




    function initPrintButtons()
    {
        // Quick overview

        $_printOverview.click(function(__event)
        {
            __event.preventDefault();

            if($('form[name="get-pdf"]').length > 0) $('form[name="get-pdf"]').remove();

            var action = $(this).attr('href');

            var html = '<form name="get-pdf" action="' + action + '" style="display:block; width:0; height:0; opacity:0;" method="post">';
            html += '<input name="type" type="hidden" value="overview">';
            html += '<input name="member_parties" type="hidden" value="">';
            html += '</form>';

            $('body').append(html);

            $('form[name="get-pdf"] input[name="member_parties"]').val(JSON.stringify(MEMBERS));

            $('form[name="get-pdf"]').submit();
        });


        // Print All

        $_printAll.click(function(__event)
        {
            __event.preventDefault();

            if($('form[name="get-pdf"]').length > 0) $('form[name="get-pdf"]').remove();

            var action = $(this).attr('href');

            var html = '<form name="get-pdf" action="' + action + '" style="display:block; width:0; height:0; opacity:0;" method="post">';
            html += '<input name="type" type="hidden" value="all">';
            html += '<input name="member_parties" type="hidden" value="">';
            html += '</form>';

            $('body').append(html);

            $('form[name="get-pdf"] input[name="member_parties"]').val(JSON.stringify(MEMBERS));

            $('form[name="get-pdf"]').submit();
        });


        // Print Country

        $_printCountry.click(function(__event)
        {
            __event.preventDefault();

            if($('form[name="get-pdf"]').length > 0) $('form[name="get-pdf"]').remove();

            var action = $(this).attr('href');
            var countryName = $(this).data('name');
            var country = getCountryWithName(countryName);

            if(country == null)
            {
                alert('Sorry, no match found for this country.');
                return;
            }

            var html = '<form name="get-pdf" action="' + action + '" style="display:block; width:0; height:0; opacity:0;" method="post">';
            html += '<input name="type" type="hidden" value="country">';
            html += '<input name="country" type="hidden" value="">';
            html += '</form>';

            $('body').append(html);

            $('form[name="get-pdf"] input[name="country"]').val(JSON.stringify(country));

            $('form[name="get-pdf"]').submit();
        });


        // Print Party

        $_printParty.click(function(__event)
        {
            __event.preventDefault();

            if($('form[name="get-pdf"]').length > 0) $('form[name="get-pdf"]').remove();

            var action = $(this).attr('href');
            var countryName = $_printCountry.data('name');
            var country = getCountryWithName(countryName);

            if(country == null)
            {
                alert('Sorry, no match found for this country.');
                return;
            }

            var typeMember = country.type_member;
            var partyArrayId = $(this).data('index');
            var party = country.parties[partyArrayId];

            var html = '<form name="get-pdf" action="' + action + '" style="display:block; width:0; height:0; opacity:0;" method="post">';
            html += '<input name="type" type="hidden" value="party">';
            html += '<input name="country_name" type="hidden" value="' + party.country_name + '">';
            html += '<input name="type_member" type="hidden" value="' + typeMember + '">';
            html += '<input name="party" type="hidden" value="">';
            html += '</form>';

            $('body').append(html);

            $('form[name="get-pdf"] input[name="party"]').val(JSON.stringify(party));

            $('form[name="get-pdf"]').submit();
        });
    }




    function checkUrlHash()
    {
        if(window.location.hash)
        {
            var hash = window.location.hash;
            var countryName = hash.substr(1);
            var country = getCountryWithName(countryName);

            if(country != null) openCountry(country);

            return true;
        } else {

            return false;
        }
    }



    function initTabType()
    {
        $('.js__ml-tab').bind('click', function(){
            $('.js__ml-tab, .ml__cols').toggleClass('active');
        });

        $('.js__country-elt').bind('click', function(){
            //onClickMapArea({'key': $(this).data('country')});
            country = getCountryWithName($(this).data('country'));
            openCountry(country);
        });

    }


    function initMemberListView()
    {
        $_panelScrollView.removeClass('p-details-2');
        $_panelScrollView.addClass('p-details-2');
        openPanelViews();
    }



    function initCountriesZooms()
    {
        $('.js-countries-zooms a').click(function(__event)
        {
            __event.preventDefault();

            var countryName = $(this).data('name');
            var country = getCountryWithName(countryName);

            if(country == null)
            {
                alert('Sorry, no match found for this country.');
                return;
            }

            openCountry(country);
        });
    }


    $(document).ready(function()
    {
        $_map = $('#map');
        $_countriesSelect = $('.js-countries-list select');
        $_panelViews = $('.js-panel-views');
        $_panelScrollView = $_panelViews.find('.js-scrollview');
        $_panelParties = $_panelScrollView.find('.js-parties');
        $_panelParty = $_panelScrollView.find('.js-party');
        $_panelSearchResult = $_panelScrollView.find('.js-search-result');
        $_printOverview = $('.js-print-overview');
        $_printAll = $('.js-print-all');
        $_printCountry = $('.js-print-country');
        $_printParty = $('.js-print-party');

        $_printCountry.hide();
        $_printParty.hide();

        _partiesTemplate = $_panelParties.html();
        _partyTemplate = $_panelParty.html();
        _searchResultTemplate = $_panelSearchResult.html();

        _socialsClasses = [
            {name:'facebook', icon:'facebook'},
            {name:'twitter', icon:'twitter'},
            {name:'linkedin', icon:'linkedin'},
            {name:'flickr', icon:'flickr'},
            {name:'youtube', icon:'youtube-play'},
            {name:'instagram', icon:'instagram'}
        ];

        resetParties();
        resetParty();
        resetSearchResults();

        initCountriesSelect();
        initCountriesZooms();
        initMap();
        if(_enableMapResponsiveness) initResize();
        initSearchForm();
        initPrintButtons();

        if (! checkUrlHash()) {
            initMemberListView();
        }
        initTabType();
    });
});